import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { alpha } from '@mui/system';
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_NEUTRAL_GREY_500, PROMETHEAN_NEUTRAL_GREY_700, PROMETHEAN_NEUTRAL_GREY_800, PROMETHEAN_NEUTRAL_GREY_900, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_TEXT, PROMETHEAN_MID_PURPLE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_LAVENDER } from '../styles/colors/colors';
export var isDarkMode = function isDarkMode(color) {
  return color === 'white' || color === 'lavender';
};
export var ROOT_PREFIX = 'EmbersInteractiveIcon-root';
var colorMap = {
  grey: PROMETHEAN_NEUTRAL_GREY_700,
  purple: PROMETHEAN_PURPLE_GRAPE,
  white: PROMETHEAN_NEUTRAL_WHITE,
  lavender: PROMETHEAN_LAVENDER,
  text: PROMETHEAN_TEXT
};
var textBorderMap = {
  grey: PROMETHEAN_NEUTRAL_GREY_800,
  purple: PROMETHEAN_MID_PURPLE,
  white: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.5),
  lavender: PROMETHEAN_LAVENDER
};
var borderMap = {
  grey: PROMETHEAN_NEUTRAL_GREY_900,
  purple: PROMETHEAN_PURPLE_GRAPE,
  white: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.5),
  lavender: PROMETHEAN_LAVENDER
};
var getOpacity = function getOpacity(theme) {
  switch (theme) {
    case 'white':
      return {
        hover: 0.1,
        active: 0.4,
        focus: 0.2
      };
    case 'grey':
      return {
        hover: 0.1,
        active: 0.3,
        focus: 0.2
      };
    case 'lavender':
      return {
        hover: 0.1,
        active: 0.4,
        focus: 0.2
      };
    default:
      return {
        hover: 0.1,
        active: 0.3,
        focus: 0.2
      };
  }
};
export var getIconButtonTheme = function getIconButtonTheme(hoverColor, iconColor) {
  var bgColor = colorMap[hoverColor];
  var borderColor = iconColor === 'text' ? textBorderMap[hoverColor] : borderMap[hoverColor];
  var focusColor = isDarkMode(hoverColor) ? PROMETHEAN_NEUTRAL_WHITE : PROMETHEAN_BLUE;
  return createTheme({
    components: {
      MuiIconButton: {
        styleOverrides: {
          root: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
            height: '34px',
            width: '34px',
            border: '1px solid transparent',
            i: {
              fontSize: '24px',
              '&:before': {
                color: colorMap[iconColor]
              }
            },
            '&:after': {
              content: '""',
              position: 'absolute',
              top: '-4px',
              width: 40,
              height: 40
            }
          }, "&.".concat(ROOT_PREFIX, "-small"), {
            i: {
              fontSize: '16px'
            }
          }), "&.".concat(ROOT_PREFIX, "-selected"), {
            border: "1px solid ".concat(hoverColor === 'white' ? PROMETHEAN_NEUTRAL_WHITE : borderColor)
          }), '@media (hover: hover)', {
            '&:hover': {
              background: alpha(bgColor, getOpacity(hoverColor).hover),
              border: "1px solid ".concat(borderColor)
            },
            '&:active': {
              background: alpha(hoverColor === 'grey' ? PROMETHEAN_NEUTRAL_GREY_500 : bgColor, getOpacity(hoverColor).active),
              border: "1px solid ".concat(hoverColor === 'grey' ? PROMETHEAN_NEUTRAL_GREY_900 : hoverColor === 'white' ? alpha(PROMETHEAN_NEUTRAL_WHITE, 0.8) : borderColor)
            },
            '&:focus-visible': {
              background: 'none',
              border: "2px solid ".concat(focusColor),
              div: {
                border: 'none'
              }
            }
          }), '&.Mui-disabled', {
            i: {
              '&:before': {
                color: isDarkMode(hoverColor) ? PROMETHEAN_NEUTRAL_GREY_800 : PROMETHEAN_NEUTRAL_DARK_GREY
              }
            }
          })
        }
      }
    }
  });
};